export default "__VITE_ASSET__75ebf68d__"